import { Snackbar } from '@material-ui/core';
import copy from 'copy-to-clipboard';
import React, { useCallback, useMemo } from 'react';
import { useBooleanState } from 'react-use-object-state';

interface Props {
  children: any;
  text: string;
}

const CopyToClipboard = ({ text, children }: Props) => {
  const clipboardSnackbarOpen = useBooleanState(false);

  const handleCopy = useCallback(() => {
    copy(text);
    clipboardSnackbarOpen.setTrue();
  }, [text]);

  return (
    <>
      {useMemo(
        () =>
          React.Children.map(children, (child) => {
            return React.cloneElement(child, {
              onClick: handleCopy,
            });
          }),
        [handleCopy, children]
      )}

      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        autoHideDuration={3000}
        open={clipboardSnackbarOpen.state}
        message="Copied to clipboard"
        onClose={clipboardSnackbarOpen.setFalse}
      />
    </>
  );
};

export default CopyToClipboard;
